import type { AppConfigInput } from '@nuxt/schema'
import ModuleConfig from './moduleConfig.json'

export default defineAppConfig<AppConfigInput>(ModuleConfig)
